import * as React from 'react'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

interface LegalEntity {
  id: number
  legalName?: string | null
}

interface SelectorProps {
  legalEntities: LegalEntity[]
  selectedLegalEntity?: LegalEntity | null
  mandatory?: boolean
  noneOption?: string
  error?: string
  readOnly: boolean
  onSelectLegalEntity: (selected?: LegalEntity) => void
}
export const LegalEntitySelector = ({
  legalEntities,
  selectedLegalEntity,
  mandatory = false,
  noneOption,
  error,
  readOnly,
  onSelectLegalEntity,
}: SelectorProps) => {
  const handleOnChange = (value: string) => {
    onSelectLegalEntity(legalEntities.find((le) => le.id === Number(value)))
  }

  const legalEntityOptions = legalEntities.map((legalEntity) => ({
    value: legalEntity.id,
    label: legalEntity.legalName || '',
  }))

  return (
    <Select
      readonly={readOnly}
      mandatory={mandatory}
      label={i18n.t('finance.invoices.detail.fields.legal_entity')}
      options={legalEntityOptions}
      onChange={handleOnChange}
      value={selectedLegalEntity ? String(selectedLegalEntity.id) : undefined}
      none={noneOption}
      error={error}
    />
  )
}
